module.exports = __webpack_public_path__ + "assets/img/vue_template_colon_props.566e3495.jpg";